import { HgSupportedLanguage } from '@smg-real-estate/domus';

const imageModules = import.meta.glob<string>('@/assets/images/whats-new/*', {
  eager: true,
  import: 'default',
});

const imagesByFileName = new Map(
  Object.entries(imageModules).map(([path, url]) => [path.slice(path.lastIndexOf('/') + 1), url]),
);

export function resolveWhatsNewImage(
  baseName: string,
  locale: HgSupportedLanguage,
): string | undefined {
  return imagesByFileName.get(`${baseName}_${locale.toUpperCase()}.webp`);
}
